import { Splide } from "@splidejs/react-splide"
import { Box, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import "@splidejs/react-splide/css"

export const Carousel = (props) => {
  const { children, options = {}, sx = {}, ...restProps } = props

  const theme = useTheme()
  const styleOverrides = theme.components[`VuiCarousel`]?.styleOverrides || {}
  const { root } = styleOverrides
  return (
    <Box sx={deepmerge(root, sx)}>
      <Splide
        {...restProps}
        options={{
          rewind: true,
          perPage: 1,
          gap: "5rem",
          padding: { left: 24, right: 24 },
          pagination: false,
          arrows: false,
          ...options,
        }}
        aria-label="Carousel"
      >
        {children}
      </Splide>
    </Box>
  )
}
